import 'moment/locale/ru'; // импортируем русскую локаль
import {API_REPORTS_REPORT1} from "../../../service/api.endpoint";
import {v4 as uuidv4} from "uuid";
import GetTaskResult from "../../../component/result.dramatiq.cmp";
import MainPageReport from "./mainReport";
import http from "../../../service/axiosConfig";


const ReportToExcel = async (date: string, setLoading: any, data?: any, options?: any) => {

    if (data) {
        MainPageReport(data, setLoading, date);
    } else {
        // Генерируем UUID для таска драматик
        const requestId = uuidv4();
        options?.onRequestId?.(requestId);

        const response = await http.get(API_REPORTS_REPORT1, {params: {date: date, requestId: requestId}})

        if (response.data['status'] === 'OK') {
            let dramatiqResult = false
            let progressResult = false

            const fetchProgress = async () => {
                if (progressResult || dramatiqResult) {
                    return;
                }
                try {
                    const progressTask = await GetTaskResult(`report1:progress:${requestId}`);
                    if (progressTask.data) {
                        options?.onProgress?.(progressTask.data);
                    }
                } catch (e) {
                    // прогресс не критичен: финальный результат опрашивается отдельно
                }
                setTimeout(fetchProgress, 2000);
            }

            // получение результата таск
            const fetchResult = async () => {
                let resultTask = await GetTaskResult(requestId);
                if (!resultTask.data) {
                    setTimeout(fetchResult, 2000);
                    return;
                } else {
                    MainPageReport(resultTask, setLoading, date)
                    dramatiqResult = true
                    progressResult = true
                    options?.onProgress?.({
                        status: 'DONE',
                        progress: 100,
                        message: 'Отчет сформирован'
                    });
                }
            }
            // циклим пока не придет выполненная таска от драматик
            if (!dramatiqResult) {
                await fetchProgress();
                await fetchResult();
            }
        }
    }
};

export default ReportToExcel;
